import axios from '../../http'
import {changeOrdersNum} from '../../../common/bus'
import {API} from "../../const"

const api = API+'/orders';

const error = (name) => (e) => console.error(name + ':=>', e);

export default function save(params, cb, fcb = error('save')) {
  axios.post(api, params).then(d=> {
    changeOrdersNum0();
    cb(d.data.content);
  }).catch(d => fcb(d));
}

export function initOrdersNum() {
  changeOrdersNum0();
}

function countOrdersNum(cb, fcb = error('countOrdersNum')) {
  axios.get(api).then(d => {
    cb(d.data.tabs)
  }).catch(d => fcb(d))
}

function changeOrdersNum0() {
  countOrdersNum(tabs=>{
    let ordersNum = [];
    tabs.forEach(tab=>{
      ordersNum.push(tab.count)
    });
    changeOrdersNum(ordersNum);
  })
}
